import React from "react";

const SelectedCircle = (props) => {
  const { isActive, isSelected, itemType, monthName, dayNumber } = props;
  function className() {
    let cname = "selected-circle";
    if ((itemType && itemType === "appointment") || itemType === "task") {
      isActive ? (cname += " green-border") : (cname += " red-border");
    }
    return cname;
  }
  return (
    <>
      <div className={className()} id="calendar-selected-circle">
        <div className="tiny-month-name">{monthName}</div>
        <div className="selected-day-number">{dayNumber}</div>
      </div>
      {isActive && isSelected && (
        <div className="selected-circle same-day red-border" />
      )}
    </>
  );
};

export default SelectedCircle;
